<template>
  <div class="hvh-flex column date-range-picker" data-app>
    <div>{{ header }}</div>
    <slot name="menu" />
    <div class="hvh-flex space-between align-center">
      <div style="width: 19px" v-if="helpText" />
      <div class="hvh-flex align-baseline grow-1">
        <div class="grow-1">
          <HvhDatePicker :value="value.from" :min="min" :max="value.to || max" @input="$emit('input', { ...value, from: startDate($event) })" @reset="$emit('reset-from')">
            <template #activator="{ on }">
              <span class="fs-12px text--primary mb-0 clickable" v-on="on">
                {{ formatDate(value.from) }}
              </span>
            </template>
          </HvhDatePicker>
        </div>
        <span class="fs-12px text--primary mb-0 px-2">-</span>
        <div class="grow-1">
          <HvhDatePicker :value="value.to" :min="value.from || min" :max="max" @input="$emit('input', { ...value, to: endDate($event) })" @reset="$emit('reset-to')">
            <template #activator="{ on }">
              <span class="fs-12px text--primary mb-0 clickable" v-on="on">
                {{ formatDate(value.to) }}
              </span>
            </template>
          </HvhDatePicker>
        </div>
      </div>
      <div v-if="helpText">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon size="19" color="primary" v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          <span>{{ helpText }}</span>
        </v-tooltip>
      </div>
    </div>
    <div style="align-self: flex-end" v-if="footer">{{ footer }}</div>
  </div>
</template>
<script>
import moment from 'moment';
import HvhDatePicker from '../form/datePicker/HvhDatePicker.vue';
export default {
  components: { HvhDatePicker },
  props: ['value', 'header', 'footer', 'min', 'max', 'helpText'],
  methods: {
    formatDate(date) {
      return moment.utc(date).format('MM/DD/YYYY');
    },
    startDate(date) {
      return moment.utc(date).toISOString();
    },
    endDate(date) {
      return moment.utc(date).toISOString();
    },
  }
}
</script>

<style lang="scss" scoped>
.date-range-picker {
  border: 1px solid rgb(199, 207, 211);
  border-radius: 8px;
  padding: 10px 4px 4px 4px;
  background-color: white;
  margin-top: 10px;
  overflow: hidden;
}
</style>